import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountService } from 'src/app/shared/account.service';
import { map } from 'rxjs/operators';

@Injectable()
export class CanactivateviaadminService implements CanActivate {

  constructor(private accountService: AccountService, private router: Router) { }


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.accountService.isAdmin().pipe(map(auth => {
      console.log("admiiiiiiiiiiiiiiiin")
      if (auth) {
        return true;
      }
      setTimeout(() => {
        this.router.navigate(['/login']);
      })
      return false;
    }))
  }

}
